import styles from 'components/Dropdown/dropdown.module.scss'
import {
  Button,
  Container,
  Dropdown,
  DropdownItem,
  Icon,
  Popover,
  Typography,
} from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import dropdownStyles from 'components/DropdownSortingMenu/dropdown-sorting-menu.module.scss'

const DropdownSortingMenu = ({
  className = '',
  id,
  sorting,
  onSortChange,
  i18nKey,
  sortingRuleMap = {},
  children,
  buttonLabelPrefix = null,
}) => {
  const { t } = useTranslation()
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()

  const [sortingControlPhrase, setSortingControlPhrase] = useState('')

  const popupState = usePopupState({
    variant: 'popover',
    id: 'dropSortingMenu-' + id,
  })

  const setSorting = useCallback(
    (payload) => {
      onSortChange(payload)
      popupState.close()
    },
    [onSortChange, popupState],
  )

  useEffect(() => {
    setSortingControlPhrase(sortingRuleMap[sorting.prop][sorting.direction])
  }, [sorting.direction, sorting.prop])

  return (
    <Container className={className} display={'flex'} key={'popover-' + id}>
      <Button
        size={'s'}
        variant={'link'}
        noWrap
        className={dropdownStyles['button']}
        color={'inherit'}
        endIcon={
          <Icon
            name={
              sorting.direction === 'desc' ? 'sort-up-down' : 'sort-down-up'
            }
            size={'m'}
          />
        }
        {...bindTrigger(popupState)}
      >
        <Typography variant={'Body-Forms-20'}>
          {buttonLabelPrefix}
          {t(`${i18nKey}.${sortingControlPhrase}`)}
        </Typography>
      </Button>

      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 12,
          horizontal: 'left',
        }}
      >
        <Dropdown
          className={styles['dropdownMenu']}
          onClick={() => popupState.isOpen && popupState.close()}
        >
          {Object.keys(sortingRuleMap).map((sortingProp) =>
            Object.keys(sortingRuleMap[sortingProp]).map((sortingDirection) => (
              <DropdownItem
                className={dropdownStyles['dropdown-row']}
                key={'sorting-rule-' + sortingDirection}
                onClick={() =>
                  setSorting({
                    prop: sortingProp,
                    direction: sortingDirection,
                  })
                }
              >
                {t(
                  `${i18nKey}.${sortingRuleMap[sortingProp][sortingDirection]}`,
                )}
              </DropdownItem>
            )),
          )}
          {children}
        </Dropdown>
      </Popover>
    </Container>
  )
}

DropdownSortingMenu.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  sorting: PropTypes.object,
  onSortChange: PropTypes.func,
  i18nKey: PropTypes.string,
  sortingRuleMap: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.element),
  buttonLabelPrefix: PropTypes.string,
}

export default DropdownSortingMenu
